import { useRecoilValue } from 'recoil';
import { VEHICLE_TYPE_CAR } from '../../../constants/vehicle';
import { currentStateState } from '../../../storage/client';
import { SecondaryDeviceDetail } from '../../../types/device';
import VehicleIcon from './VehicleIcon';

export function PrimaryVehicleIcon({ device }: { device: SecondaryDeviceDetail }) {
  const currentState = useRecoilValue(currentStateState(device.ident));
  const initialVehicleColor = currentState?.asset.vehicle?.color;

  return (
    <VehicleIcon
      vehicleType={VEHICLE_TYPE_CAR}
      color={initialVehicleColor ?? device.color}
    />
  );
}
